import axios from 'axios';
import trimEnd from 'lodash-es/trimEnd';

import type { DynamicLayoutDefinition } from '../../pages/cms/management/layouts/_partials/dynamic-layout';

export default class CmsSettingsService
{
    public static async getConfig(name: string = '')
    {
        return (await axios.get<PluginsSettings>(trimEnd(`admin/cms/settings/${name}`, '/'))).data;
    }

    public static async getThemeConfig(name: string)
    {
        return (await axios.get<ThemeSettings>(`admin/cms/settings/theme/${name}`)).data;
    }
}

export interface PluginsSettings
{
    bodyLengthLimitMB: number;
    i18n: {
        locale: string;
        languages: Record<string, string>;
    };
    modules: PluginSettings[];
    widgets: PluginSettings[];
}

export interface PluginSettings
{
    id: string;
    name: string;
    icon?: string;
    settings?: boolean;
    unique?: boolean;
}

export interface ThemeSettings
{
    sections: Record<string, string>;
    layouts: Record<string, LayoutSettings>;
    widgets: Record<string, WidgetSettings>;
}

export interface LayoutSettings
{
    name: string;
    sections: string[];
    design: Record<string, DesignSettings>;
    moduleContent?: {
        row: string;
        column: string;
    } | null;
    layoutMode?: 'legacy' | 'dynamic';
    layoutDefinition?: DynamicLayoutDefinition | null;
}

export interface DesignSettings
{
    row: string;
    column: string;
}
export interface WidgetSettings
{
    sections: string[];
    default: Record<string, string>;
    override: Record<string, Record<string, string>>;
}
